const FilterForm = () => {
  return "Filter form";
};
export default FilterForm;